export enum LogLevels {
  silent = 0,
  error,
  warn,
  info,
  debug,
}

export type LogLevel = keyof typeof LogLevels

export interface WebLogger {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error(mesasge: any, ...data: any[]): void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  warn(mesasge: any, ...data: any[]): void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info(mesasge: any, ...data: any[]): void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debug(mesasge: any, ...data: any[]): void
}
